import { type Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Switch } from '@/components/atoms/Switch';

import type { ProviderFormValues } from '../form/formModel';

export interface PenActiveSwitchProps {
    id: string;
    base: `pens.${string}`;
    control: Control<ProviderFormValues>;
}

/** A pen's Active switch, named by its own label. */
function PenActiveSwitch({ id, base, control }: PenActiveSwitchProps) {
    const { t } = useTranslation();
    return (
        <Controller
            control={control}
            name={`${base}.isActive`}
            render={({ field }) => (
                <Switch
                    id={id}
                    label={t('providerConfig.pens.active')}
                    checked={field.value}
                    onCheckedChange={field.onChange}
                />
            )}
        />
    );
}

export default PenActiveSwitch;
export { PenActiveSwitch };
